import styled from "styled-components";
import React from "react";
import { PodSettings } from "../../assets/Podcast/PodSettings";
import { PodAnalytics } from "../../assets/Podcast/PodAnalytics";
import { PodFolder } from "../../assets/Podcast/PodFolder";
import { PodExam } from "../../assets/Podcast/PodExam";
import { gql, useQuery } from "@apollo/client";
import { Loading } from "../../components/Loading";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { TextBtn } from "../../components/inputs/TextBtn";

const StyleCss = styled.div`
  .campaign {
    margin: 7.5px;
    padding: 5px 10px;
    border: 1px solid var(--n-grey-3);
    background-color: var(--n-grey-1);
    border-radius: 8px;
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    text-decoration: none;
    color: var(--n-text-2);
    transition: all 0.15s ease-in-out;
    :hover {
      border: 1px solid var(--n-grey-7);
      color: var(--n-text-1);
    }
    &.header {
      border: none;
      background-color: transparent;
      margin: 7.5px 7.5px 0;
      font-weight: 500;
      .column {
        padding: 0.5rem 0.5rem 0;

      }
    }
    .column {
      padding: 0.5rem;
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 1rem;
    .title-value{
      display: flex;
      gap: 0.5rem;
      .tv-title {
        font-weight: 600;
      }
    }
    .link {
      text-decoration: none;
      color: inherit;
      max-width: 300px;
    }
    .title-table {
      margin: 1rem 0 0;
      font-weight: 500;
      font-size: 1.2rem;
    }
    .contract {
      padding: 0.7rem 1rem;
      display: flex;
      box-shadow: 0px 4px 8px -2px #00000040;
      border-radius: 4px;
      text-decoration: none;
      color: inherit;
      transition: all 0.2s ease-in-out;
      :hover {
        background-color: #00000010;
      }
      .expand {
        flex-grow: 1;
      }
      .date {
        width: 25%;
      }
      .end {
        min-width: 50px;
      }
      .more-info {
        color: blue;
        cursor: pointer;
      }
      &.header {
        font-weight: 700;
        :hover {
          background-color: inherit;
        }
      }
    }
  }
`;
export const Exams_Query = gql`
  query OneExamsQuery(
    $_id: ID!
  ){
    getExamForUser(
      _id: $_id
    ) {
        _id
        Title
        Description
        StartDate
        TotalScore
        PassScore
        Time
        Atemps
    }
    getPastExamAnsForUser(
      _id: $_id
    ) {
      _id
      ExamBase
      Timestamp
      Score
      Passed
    }
  }
`
function WorkPageExamPage(props) {
  const exam = useQuery(Exams_Query, {
    variables: {
      _id: props.match.params._id
    },
    fetchPolicy: "network-only"
  });
  if(exam.loading){
    return (
      <StyleCss className="main-box">
        <div className="title-bar">
          <div className="title">
            <div className="icon"><PodExam/></div>
            <div className="text"></div>
          </div>
        </div>
        <div className="content">
          <Loading/>
        </div>
      </StyleCss>
    )
  }
  let data = {}
  if(exam.data.getExamForUser){
    data = exam.data.getExamForUser
  }
  const makeTable = () => {
    let data = []
    if(exam.data.getPastExamAnsForUser){
      data = exam.data.getPastExamAnsForUser
    }
    return data.map((v, i) => {
      let newDate = new Date(v.Timestamp * 1000);
      let newDateString = newDate.getFullYear() + "/" + newDate.getMonth() + "/" + newDate.getDate()
      return (
        <div className="contract" key={i}>
          <div className="date">{newDateString}</div>
          <div className="expand"></div>
          <div className="date">{v.Score}</div>
          <div className="end">
              {
                (v.Passed)? "Passed" : "Failed"
              }
          </div>
        </div>
      )
    })
  }
  return (
    <StyleCss className="main-box">
      <div className="title-bar">
          <div className="title">
            <div className="icon"><PodExam/></div>
            <div className="text">{data.Title}</div>
          </div>
      </div>
      <div className="content">
        <div className="title-value">
          <div className="tv-title">
            Name:
          </div>
          <div className="tv-value">
            {data.Title}
          </div>
        </div>
        <div className="title-value">
          <div className="tv-title">
            Description:
          </div>
          <div className="tv-value">
            {data.Description}
          </div>
        </div>
        <div className="title-value">
          <div className="tv-title">
            Total score:
          </div>
          <div className="tv-value">
            {data.TotalScore}
          </div>
        </div>
        <div className="title-value">
          <div className="tv-title">
            Minimum score to pass:
          </div>
          <div className="tv-value">
            {data.PassScore}
          </div>
        </div>
        <div className="title-value">
          <div className="tv-title">
            Exam time:
          </div>
          <div className="tv-value">
            {data.Time} min
          </div>
        </div>
        <div className="title-value">
          <div className="tv-title">
            Attempts Remaining:
          </div>
          <div className="tv-value">
            {data.Atemps}
          </div>
        </div>
        {
          (data.Atemps) ? (
            <Link to={"/verified-exam/" + data._id} className={"link"}>
              <TextBtn
                text={"Start Exam"}
                type={""}
              />
            </Link>
          ) : (
            <Link to={"#"} className={"link"}>
              <TextBtn
                disabled={true}
                text={"Start Exam"}
                type={""}
              />
            </Link>
          )
        }
        
        <div className="title-table">
          Previous attempts:
        </div>
        <div className="contract header">
          <div className="date">Date</div>
          <div className="expand"></div>
          <div className="date">Score</div>
          <div className="end">
            status
          </div>
        </div>
        {makeTable()}
      </div>
    </StyleCss>
  )
}
export default WorkPageExamPage;